import styled from 'styled-components';

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
	margin: -13% 0 0 0;
	padding: 5% 0% 4% 0%;
console.log('SectionWrapper styles:', SectionWrapper);
console.log('HeadingWrapper styles:', HeadingWrapper);
console.log('ArticlesWrapper styles:', ArticlesWrapper);
console.log('LoadingContainer styles:', LoadingContainer);`;

export const HeadingWrapper = styled.div``;
export const ArticlesWrapper = styled.div`
	width: 100%;
	margin-top: 1rem;
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	background: #cccccc;
	padding: 6%;
`;
